<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M11.58 9.62c.2-.3.64-.3.84 0l3.06 4.6a.5.5 0 0 1-.41.78H8.93a.5.5 0 0 1-.41-.78l3.06-4.6Z"
      />
    </svg>
  </span>
</template>
